import React, { useEffect, useRef } from 'react';
import { INTERNSHIP_TRACKS } from '../data/siteData';

export default function Internship() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          el.querySelectorAll('.rv, .rl, .rr, .rs').forEach((n) => n.classList.add('on'));
          obs.unobserve(el);
        }
      },
      { threshold: 0.07 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const perks = [
    { icon: '💼', text: 'Real project exposure from day 1' },
    { icon: '🧑‍🏫', text: 'Senior developer mentorship' },
    { icon: '🏆', text: 'Performance-based PPO offers' },
    { icon: '📜', text: 'Industry-recognised certificate' },
    { icon: '🌐', text: 'Remote-first, flexible schedule' },
    { icon: '💰', text: 'Stipend for selected candidates' },
  ];

  return (
    <section className="intern-sec" id="internship" ref={sectionRef} aria-labelledby="internship-heading">
      <div className="wrap">
        <div className="ib-banner rv">
          <div className="ib-left">
            <div className="chip" style={{ marginBottom: '.8rem' }}>🎓 Internship Programme</div>
            <h2 id="internship-heading">Launch Your Tech Career</h2>
            <p>
              Join JSDevBrains for a 3–6 month structured internship and work on AI, Cloud, and App
              projects that reach real users worldwide. We invest in the next generation of builders.
            </p>

            {/* Tracks */}
            <div className="ib-tracks">
              {INTERNSHIP_TRACKS.map((t) => (
                <div className="ib-track" key={t.label}>
                  <span>{t.icon}</span> {t.label}
                </div>
              ))}
            </div>

            {/* Perks */}
            <div className="ib-perks">
              {perks.map((p) => (
                <div className="ib-perk" key={p.text}>
                  <span className="ib-perk-ic">{p.icon}</span>
                  <span>{p.text}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '.75rem', flexWrap: 'wrap', marginTop: '2rem' }}>
              <a
                href="https://wa.me/918123629993?text=I want to apply for the JSDevBrains internship programme"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-green"
              >
                Apply Now →
              </a>
              <a href="#contact" className="btn btn-outline-g" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}>
                📋 Learn More
              </a>
            </div>
          </div>

          {/* Right: stats card */}
          <div className="ib-right rr">
            <div className="ib-stats-card">
              <div className="ib-card-title">2025–2026 Cohort</div>
              <div className="ib-card-stats">
                {[
                  { n: '24', l: 'Seats Available', c: '#00B14F' },
                  { n: '6', l: 'Tech Tracks', c: '#3B82F6' },
                  { n: '3–6', l: 'Months Duration', c: '#7C3AED' },
                  { n: '80%', l: 'Conversion Rate', c: '#F59E0B' },
                ].map((s) => (
                  <div className="ib-cs" key={s.l}>
                    <div className="ib-cs-n" style={{ color: s.c }}>{s.n}</div>
                    <div className="ib-cs-l">{s.l}</div>
                  </div>
                ))}
              </div>
              <div className="ib-card-note">
                🚀 Applications open — Rolling admissions
              </div>
              <a
                href="https://wa.me/918123629993?text=Internship application"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-green"
                style={{ width: '100%', justifyContent: 'center', marginTop: '.5rem' }}
              >
                WhatsApp to Apply
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
